// These mappings are made Title cased just like AWS Cognito is for compatibility
// TODO: Keys should be lowercase
const ERROR_TYPES = {
  UnauthorizedException: 'UnauthorizedException',
  InvalidPasswordException: 'InvalidPasswordException',
  LimitExceededException: 'LimitExceededException',
  UserNotFoundException: 'UserNotFoundException',
  NotAuthorizedException: 'NotAuthorizedException',
  CodeMismatchException: 'CodeMismatchException',
  InvalidParameterException: 'InvalidParameterException',
  NetworkConnectivityException: 'NetworkConnectivityException',
  DefaultException: 'DefaultException',
  LockError: 'LockError',
  ReleaseError: 'ReleaseError',
  notAuthenticated: 'not authenticated',
  userNotAuthenticated: 'The user is not authenticated',
  passwordResetRequiredException: 'PasswordResetRequiredException',
};

const genericAuthFailure =
  'Your username/password is incorrect - you may have typed it incorrectly or your password may have been reset due to age.  To change your password, you can click the "Reset password" button below.';

// Error Messages to the user
const ERROR_MESSAGES = {
  // Hit when user enters weak password on forgot password
  [ERROR_TYPES.InvalidPasswordException]:
    'Selected Password Does Not Conform To Requirements',
  // User entered incorrect password too many times NOTE: This is cognito's message
  [ERROR_TYPES.LimitExceededException]:
    'Attempt limit exceeded, please try after some time.',
  // See https://docs.aws.amazon.com/cognito/latest/developerguide/cognito-user-pool-managing-errors.html for the source
  // of truth on the user existence error responses. At the time of writing this, our Cognito pools run in LEGACY mode,
  // returning different exceptions for incorrect password and incorrect username, allowing to fish for valid usernames.
  [ERROR_TYPES.UserNotFoundException]: genericAuthFailure,
  [ERROR_TYPES.NotAuthorizedException]: genericAuthFailure,
  // When user enters incorrect code from e-mail FIXME: Continues to password phase even with error
  [ERROR_TYPES.CodeMismatchException]: 'Incorrect Password Reset Code Entered',
  // Hit when user enters weak password on change current password
  [ERROR_TYPES.InvalidParameterException]:
    'Selected Password Does Not Conform To Requirements',
  // Default exception TODO: Confirm Language with Antonio & Bing
  [ERROR_TYPES.NetworkConnectivityException]:
    'Possible Network Disconnection, Please Verify Your Connection and Try Again',
  [ERROR_TYPES.UnauthorizedException]:
    'User Is Not Authorized To View Requested Data',
  [ERROR_TYPES.DefaultException]:
    'Error Encountered: A report has been sent to the development team',
  [ERROR_TYPES.LockError]: 'Failed to lock city data',
  [ERROR_TYPES.ReleaseError]: 'Failed to release city data',
  [ERROR_TYPES.passwordResetRequiredException]:
    "To ensure your account remains secure, we recommend updating your password periodically. It appears that your password hasn't been changed in a while. For your safety, please take a moment to reset your password. Simply click on 'Reset Password' below to begin.",
};

export { ERROR_MESSAGES, ERROR_TYPES };
